import React, { useEffect } from 'react';
import { Button as SaladButton, Row } from 'saladsoft-primitive';

import styled from 'styled-components';

// SaladButton의 props 타입을 확장
type ButtonProps = React.ComponentProps<typeof SaladButton> & {
  children: React.ReactNode;
  style?: React.CSSProperties;
  isValid?: boolean;
  onChange: (file: File) => void;
};

const UploadButton = ({ children, style, isValid = true, onChange, ...props }: ButtonProps) => {
  const [fileName, setFileName] = React.useState<string>('');

  return (
    <Container>
      <ButtonContainer isValid={isValid} style={style} {...props}>
        <Row gap={10}>
          <>{children}</>
        </Row>
        <VisuallyHiddenInput
          type="file"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setFileName(file.name);
              onChange(file);
            }
          }}
          accept=".jpg,.jpeg,.png"
        />
      </ButtonContainer>
      {fileName && <FileName>{fileName}</FileName>}
    </Container>
  );
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

const FileName = styled.span`
  color: var(--text-color, #333);
  font-size: 14px;
`;

const ButtonContainer = styled(SaladButton)<{ isValid?: boolean }>`
  background: ${({ isValid }) => (!isValid ? '#f8f8f8' : 'var(--point-color)')};
  color: ${({ isValid }) => (!isValid ? '#cbcbcb' : '#fff')};
  display: inline-flex;
  margin: 0;
  padding: 10px 20px;
  &:hover {
    background: ${({ isValid }) => (!isValid ? '#efefef' : '#730000')};
  }
`;

const VisuallyHiddenInput = styled.input`
  cursor: pointer;
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export default UploadButton;
